import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

const CODE_MIN_LENGTH = 1;
const CODE_MAX_LENGTH = 10;

const NAME_ALLOW_CHARACTERS = /^[a-zA-Z0-9\u0E00-\u0E3A\u0E40-\u0E4E_\-:,()\s]+$/;
const CODE_ALLOW_CHARACTERS = /^[a-zA-Z0-9_-]*$/;

export const ExamCenterCreationFormSchema = z.object({
  nameTH: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, { message: 'กรุณากรอก ชื่อศูนย์ทดสอบ (ภาษาไทย)' })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อศูนย์สอบต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(NAME_ALLOW_CHARACTERS, {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () เท่านั้น',
    }),
  nameEN: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, { message: 'กรุณากรอก ชื่อศูนย์ทดสอบ (ภาษาอังกฤษ)' })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อศูนย์สอบต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(NAME_ALLOW_CHARACTERS, {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () เท่านั้น',
    }),
  code: z
    .string()
    .min(CODE_MIN_LENGTH, { message: 'กรุณากรอก Exam Center Code' })
    .max(CODE_MAX_LENGTH, {
      message: `Exam Center Code ต้องมีความยาวไม่เกิน ${CODE_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(CODE_ALLOW_CHARACTERS, {
      message: 'อนุญาตเฉพาะ a-z, A-Z, 0-9 และเครื่องหมาย - _ เท่านั้น',
    }),
});

export type ExamCenterCreationFormInput = z.infer<typeof ExamCenterCreationFormSchema>;
